import { routes } from '@/ducks/routes';
import { type TRouteConfig } from '@/features/routeConfig/types';

const ROUTE_CONFIGS: Record<string, TRouteConfig> = {
  // [routes.planner.addOns.path]: {},
  [`${routes.planner.chooseCabin.path}/*`]: {
    hasBannerPlaces: true,
    hasStrikethrough: true,
  },
  [routes.planner.cabin.path]: {
    cleanup: ['calculateInvoice'],
    hasBannerPlaces: false,
  },
  [routes.planner.chooseCabin.path]: {
    cleanup: ['calculateInvoice'],
    hasBannerPlaces: true,
  },
  [routes.planner.chooseVoyage.path]: {
    cleanup: ['calculateInvoice', 'travelParty'],
    hasBannerPlaces: true,
    hasStrikethrough: true,
    nonAuthMnvv: { pickUrlParams: { withFilters: true }, redirectTo: routes.planner.chooseVoyage.path },
  },
  [routes.planner.confirmation.path]: {
    enterByLink: { redirectTo: routes.accounts.dashboard.path },
  },
  [routes.planner.fullCruiseDetails.path]: {
    cleanup: ['calculateInvoice'],
    hasBannerPlaces: true,
    hasStrikethrough: true,
  },
  [routes.planner.payment.path]: {
    enterByLink: { pickUrlParams: { withFilters: true }, redirectTo: routes.planner.chooseVoyage.path },
  },
  [routes.planner.preCheckOut.path]: {
    cleanup: ['calculateInvoice'],
    hasBannerPlaces: true,
    hasStrikethrough: true,
  },
  [routes.planner.summary.path]: {
    hasBannerPlaces: true,
    hasStrikethrough: true,
  },
};

export default ROUTE_CONFIGS;
